module.exports = __webpack_public_path__ + "static/media/phone-2.a3066879.png";